import { Map } from 'immutable';
import { connect } from 'react-redux';
import decorate from '../../utils/decorate';
import { request as queryCompetitions } from '../../modules/competitions/actions/query';
import SportCompetitionsInput from './SportCompetitionsInput.jsx';


function mapStateToProps( state ) {
    const { competitions } = state;

    return {
        competitions: competitions.get( 'items', Map() ),
        collections: competitions.get( 'collections', Map() )
    };
}

function mapDispatchToProps( dispatch ) {
    return {
        onQueryCompetitionsRequest: ( sportId, query ) => {
            dispatch( queryCompetitions( sportId, query ) );
        }
    };
}

export default decorate(
    connect( mapStateToProps, mapDispatchToProps ),
    SportCompetitionsInput
);
